import { Box } from '@material-ui/core';
import moment from 'moment';
import React, { useState, useMemo, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { showLoading } from 'src/features/videoSlice';
import VehicleTablecell from '../tables/VehicleTablecell';
import { TableVirtuoso } from 'react-virtuoso';
import { titleTableHeader } from '../tables/constance';
import { formatDisplayName } from 'src/app/utils/vehicleDisplay';

// Man streaming
const VehicleTableStreaming = ({ listVehicle }) => {
  const dispatch = useDispatch();
  const [rowActive, setRowActive] = useState(null);
  const [hoverIndex, setHoverIndex] = useState(null);
  const deviceSerial = useSelector(state => state.videoSlice.deviceSerial);

  const vehicleMapBySerial = useMemo(() => {
    const map = new Map();
    for (const vehicle of listVehicle) {
      map.set(vehicle.device_serial, vehicle);
    }
    return map;
  }, [listVehicle]);

  const findVehicle = () => {
    return vehicleMapBySerial.get(deviceSerial);
  };

  const vehicleSelected = findVehicle();

  useEffect(() => {
    if (vehicleSelected) {
      setRowActive(vehicleSelected.device_id);
    }
  }, [vehicleSelected]);

  const handleRowClick = vehicle => {
    const vehicleId = vehicle.device_id;
    if (vehicleId) {
      setRowActive(prev => (prev === vehicleId ? null : vehicleId));
    }
    dispatch(showLoading({ device_serial: vehicle.device_serial }));
  };

  return (
    <>
      <TableVirtuoso
        style={{ height: '97.5%', width: '100%' }}
        data={listVehicle}
        components={{
          Table: props => (
            <table
              {...props}
              style={{
                ...props.style,
                borderCollapse: 'collapse',
                border: '1px solid rgba(60, 64, 67, 0.15)',
                backgroundColor: '#f5f5f5',
                tableLayout: 'fixed',
              }}
            />
          ),
          TableRow: ({ item, ...props }) => {
            const isActive = item.device_id === rowActive;
            const index = Number(props['data-index']);
            return (
              <tr
                {...props}
                onClick={() => handleRowClick(item, index)}
                onMouseEnter={() => setHoverIndex(index)}
                onMouseLeave={() => setHoverIndex(null)}
                style={{
                  ...props.style,
                  borderBottom: '1px solid rgba(60, 64, 67, 0.15)',
                  cursor: 'pointer',
                  backgroundColor: isActive
                    ? '#ffe4e1'
                    : hoverIndex === index
                      ? '#ebebebff'
                      : 'transparent',
                  transition: 'background-color 0.15s linear',
                  willChange: 'background-color'
                }}
              />
            );
          }
        }}
        fixedHeaderContent={() => (
          <tr>
            {titleTableHeader.map(title => {
              return (
                <th
                  style={{
                    width: title.width,
                    border: '1px solid rgba(60, 64, 67, 0.15)',
                    padding: '3px 0px',
                    background: '#d9042f',
                    color: '#FFFFFF',
                    fontSize: '12px',
                    fontWeight: 500
                  }}
                >
                  <span
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      whiteSpace: 'pre-line'
                    }}
                  >
                    {title.name}
                  </span>
                </th>
              );
            })}
          </tr>
        )}
        itemContent={(index, vehicle) => {
          const displayText =
            vehicle?.is_display_name && vehicle?.name
              ? formatDisplayName(vehicle.name, 20)
              : vehicle.license_plate;

          return (
            <>
              <td style={{ width: titleTableHeader[0].width, height: 38, overflow: 'hidden' }}>
                <span
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    width: '100%'
                  }}
                >
                  <VehicleTablecell
                    row={vehicle}
                    index={index}
                    displayText={displayText}
                  />
                </span>
              </td>

              {vehicle.debt ? (
                <td
                  colSpan={2}
                  style={{
                    width: Number(titleTableHeader[1].width) + Number(titleTableHeader[2].width),
                    height: 38,
                    overflow: 'hidden',
                    padding: 0
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      width: '100%',
                      height: '100%',
                      justifyContent: 'center',
                      alignItems: 'center'
                    }}
                  >
                    <span style={{ color: '#D9042F', fontSize: '11px', fontWeight: 500 }}>
                      Hết hạn gói dịch vụ
                    </span>
                  </div>
                </td>
              ) : (
                <>
                  <td
                    style={{
                      width: titleTableHeader[1].width,
                      height: 38,
                      overflow: 'hidden',
                      padding: '0'
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        width: '100%',
                        height: '100%',
                        justifyContent: 'center',
                        alignItems: 'center'
                      }}
                    >
                      <span style={{ fontSize: '12px' }}>
                        {Math.floor(vehicle.speed_gps) || 0}
                      </span>
                    </div>
                  </td>

                  <td
                    style={{
                      width: titleTableHeader[2].width,
                      height: 38,
                      overflow: 'hidden',
                      padding: '0'
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        width: '100%',
                        height: '100%',
                        justifyContent: 'space-around',
                        alignItems: 'center'
                      }}
                    >
                      <span style={{ fontSize: '11px' }}>
                        {vehicle
                          ? moment.unix(vehicle.created_at).format('DD/MM HH:mm:ss')
                          : '--'}
                      </span>
                    </div>
                  </td>
                </>
              )}
            </>
          );
        }}
      />
    </>
  );
};

export default React.memo(VehicleTableStreaming);
